import { Card, CardHeader, Skeleton, View } from "@/components/ui";

export function ReviewCardSkeleton() {
  return (
    <View className="flex flex-col gap-2 rounded-lg border border-border p-4">
      <View className="flex flex-row items-center gap-1">
        <Skeleton className="h-4 w-24" />
      </View>
      <View className="flex flex-row justify-start gap-1">
        <Skeleton className="h-4 w-20" />
        <Skeleton className="h-4 w-16" />
      </View>
      <Skeleton className="h-4 w-40" />
      <View className="flex flex-col gap-1">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-3/4" />
      </View>
      <View className="mt-2 flex w-full flex-row flex-wrap gap-1">
        <View className="aspect-square w-[32%] overflow-hidden rounded-md">
          <Skeleton className="h-full w-full" />
        </View>
        <View className="aspect-square w-[32%] overflow-hidden rounded-md">
          <Skeleton className="h-full w-full" />
        </View>
        <View className="aspect-square w-[32%] overflow-hidden rounded-md">
          <Skeleton className="h-full w-full" />
        </View>
      </View>
    </View>
  );
}

export function CustomerReviewSkeleton() {
  return (
    <Card className="border-0 md:border">
      <CardHeader className="flex flex-row items-center justify-between border-secondary-border md:border-b">
        <View className="flex flex-row items-center gap-2">
          <Skeleton className="h-5 w-5 rounded" />
          <Skeleton className="h-4 w-12" />
          <Skeleton className="h-4 w-1" />
          <Skeleton className="h-4 w-16" />
        </View>
        <Skeleton className="h-8 w-20 rounded-full" />
      </CardHeader>
      <View className="flex flex-col gap-3 p-4">
        <ReviewCardSkeleton />
      </View>
    </Card>
  );
}
